var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoassets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ABABAB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31 39a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM41 41l-4.35-4.35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    x: 0.5,
    y: 0.5,
    stroke: "#ABABAB",
    rx: 31.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoassets);
export default __webpack_public_path__ + "static/media/noassets.1b3e01de0e3c374daedde6fee271625a.svg";
export { ForwardRef as ReactComponent };